export default {
    // 数据字典查询接口
    queryDicCodeInfoList(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowModelManage/queryDicCodeInfoList', params, response);
    },
    // 角色下人员列表查询接口
    queryGroupInfoList(params, response) {
        window.vue.$apiAxios.postRequestBody('/WorkFlowUserGroup/queryGroupInfoList', params, response);
    },
    // 流程启用接口
    submitLeaveBill(params, response) {
        return window.vue.$apiAxios.postRequestBody('/WorkFlowDemoController/submitLeaveBill', params, response);
    },
    // 角色下人员列表查询接口
    publicProcess(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/publicProcess', params, response);
    },
    // 流程拒绝
    reject(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/reject', params, response);
    },
    queryTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/findTemplate', params, response);
    },
    //流程删除
    deleteProIns(params, response) {
        window.vue.$apiAxios.postRequestBody('/activitiDemo/deleteProIns', params, response);
    }
};
